import { addDays, isSameDay } from "date-fns";

export const getStartDateForTransactions = (date?: Date) => {
  if (!date) return undefined;

  if (isSameDay(date, new Date())) {
    return addDays(date, 5);
  }

  return date;
};
